import { render } from "./FilesForm.vue?vue&type=template&id=76b4596d"
import script from "./FilesForm.vue?vue&type=script&lang=js"
export * from "./FilesForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__